var map = {
	"./arrowLeft.png": "d6b5",
	"./arrowRight.png": "dbfd",
	"./autobole.png": "7f09",
	"./dazong.png": "be3b",
	"./didi.png": "7c38",
	"./jp.png": "024a",
	"./mind.png": "b07f",
	"./mind1.png": "6b50",
	"./mind2.png": "6b11",
	"./preangel.png": "e163",
	"./redbook.png": "ab39",
	"./science.png": "7db5",
	"./science1.png": "a9ac",
	"./science2.png": "b91b",
	"./songben.png": "c0e7",
	"./value.png": "fbd7",
	"./value1.png": "b1f9",
	"./value2.png": "d2d8",
	"./weilai.jpeg": "ec34"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";